import React, { useEffect, useState } from 'react';
import CancelLogin from './CancelLogin'; // Adjust the import path as needed
import { initialiseDecoupledFlow } from '../actions';
import { postMessageSuccess } from '../helpers/postMessage';

/*function RevocationInfo({ revocationInfo }) {
  return (
    <p>
      {revocationInfo.text}{' '}
      <a href={process.env.REACT_APP_BANKSTATEMENTS_URL + '/' + revocationInfo.link.href} target={revocationInfo.link.target} rel="noopener noreferrer">
        {revocationInfo.link.label}
      </a>
    </p>
  );
}*/

const defaultResponsiveLimits = {
    mobile: { charLimit: 50, wordLimit: 6 },
    desktop: { charLimit: 70, wordLimit: 14 },
};

const getTruncatedText = (text, { charLimit, wordLimit }) => {
    const words = text.split(' ');
    let truncated = '';
    let wordCount = 0;

    words.some((word) => {
        if (wordCount < wordLimit && `${truncated}${truncated ? ' ' : ''}${word}`.length <= charLimit) {
            truncated += `${truncated ? ' ' : ''}${word}`;
            wordCount += 1;
            return false;
        }
        return true;
    });

    return truncated;
};

const ExpandableText = ({ text, limitConfig = {} }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 767px)').matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const updateDevice = (event) => setIsMobile(event.matches);
        mediaQuery.addEventListener('change', updateDevice);

        return () => mediaQuery.removeEventListener('change', updateDevice);
    }, []);

    const responsiveDefaults = isMobile ? defaultResponsiveLimits.mobile : defaultResponsiveLimits.desktop;
    const resolvedLimits = {
        ...responsiveDefaults,
        ...(limitConfig.default || {}),
        ...(limitConfig[isMobile ? 'mobile' : 'desktop'] || {}),
    };
    const truncatedText = getTruncatedText(text, resolvedLimits);
    const needsExpand = text.split(' ').length > resolvedLimits.wordLimit || text.length > resolvedLimits.charLimit;

    if (!needsExpand) {
        return <p style={{ marginBottom: '15px' }} dangerouslySetInnerHTML={{ __html: text }}></p>;
    }

    return (
        <p style={{ marginBottom: '15px' }} className="expandable-text">
            {!isExpanded ? (
                <span className="text-short">
                    <span dangerouslySetInnerHTML={{ __html: truncatedText }}></span>
                    <span className="text-ellipsis">...</span>{' '}
                    <a
                        href="#expand"
                        className="expand-link"
                        onClick={(event) => {
                            event.preventDefault();
                            setIsExpanded(true);
                        }}
                    >
                        more
                    </a>
                </span>
            ) : (
                <span className="text-full">
                    <span dangerouslySetInnerHTML={{ __html: text }}></span>{' '}
                    <a
                        href="#collapse"
                        className="collapse-link"
                        onClick={(event) => {
                            event.preventDefault();
                            setIsExpanded(false);
                        }}
                    >
                        less
                    </a>
                </span>
            )}
        </p>
    );
};


const Consent = (props) => {
    const [openSections, setOpenSections] = useState({});
    const [isDeidentified, setIsDeidentified] = useState(false);

    const consentData = JSON.parse(props.consentData);

    const toggleSection = (key) => {
        setOpenSections((prev) => (prev[key] ? {} : { [key]: true }));
    };

    const onCancel = () => {
        const slug = props.slug;
        props.dispatch(postMessageSuccess("data_consent_illion", {data: slug}, "cancelled"));
        props.dispatch({ type: 'LOGIN_PROCESS_CANCELLED' });
    }

    const onSubmit = (e) => {
        e.preventDefault();
        const slug = props.slug;
        props.dispatch(postMessageSuccess("data_consent_illion", {
            data: slug,
            is_deidentified: isDeidentified,
        }));
        props.dispatch(initialiseDecoupledFlow(slug, isDeidentified))
    };

    let backToSelectionBtnText = props.theme.text.backToSelectionBtn;
    let requireWinz = false;
    

    return (
        <div className="step-content">
            <div id="intro">
                <div className="consent-data-wrapper">
                    <div className="formMain">
                        {consentData.title && <h2>{consentData.title}</h2>}
                        {consentData.description && <p dangerouslySetInnerHTML={{ __html: consentData.description }}></p>}

                        {Array.isArray(consentData.keyDetails) && consentData.keyDetails.length > 0 && (
                            <div className="consent-key-details">
                                <h5><strong>Key details</strong></h5>
                                {consentData.keyDetails.map((keyDetail, keyDetailIndex) => keyDetail && (
                                    <React.Fragment key={keyDetailIndex}>
                                        {keyDetail.title && <h6><strong>{keyDetail.title}</strong></h6>}
                                        {keyDetail.description && <ExpandableText text={keyDetail.description} />}
                                    </React.Fragment>
                                ))}
                            </div>
                        )}

                        {consentData.whyAskedForData &&
                            (consentData.whyAskedForData.title || consentData.whyAskedForData.description) && (
                            <div className="why-asked-section">
                                {consentData.whyAskedForData.title && <h6><strong>{consentData.whyAskedForData.title}</strong></h6>}
                                {consentData.whyAskedForData.description && <ExpandableText text={consentData.whyAskedForData.description} limitConfig={{ mobile: { charLimit: 250, wordLimit: 24 }, desktop: { charLimit: 500, wordLimit: 50 } }} />}
                            </div>
                        )}                        

                        {Array.isArray(consentData.sections) && consentData.sections.length > 0 && consentData.sections.map((section, sectionIndex) => (
                            <React.Fragment key={sectionIndex}>
                                {section.title && <h6><strong>{section.title}</strong></h6>}
                                <div className="consent-type-section">
                                {Array.isArray(section.subSections) && section.subSections.map((sub, subIndex) => {
                                    const key = `${sectionIndex}-${subIndex}`;
                                    return (
                                        <div className={`section accordion-item ${openSections[key] ? 'active' : ''}`} key={key}>
                                            <button
                                                className="toggle-btn accordion-header"
                                                type="button"
                                                onClick={() => toggleSection(key)}
                                            >
                                                {sub.title && <span>{sub.title}</span>}
                                                <span className={`arrow icon ${openSections[key] ? 'rotate' : ''}`}></span>
                                            </button>
                                            {openSections[key] && (
                                                <div className="toggle-content accordion-content">
                                                    {sub.description && <p dangerouslySetInnerHTML={{ __html: sub.description }}></p>}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                                </div>
                            </React.Fragment>
                        ))}

                        {consentData.accessUpTo && (
                            <div className="access-upto-section">
                                {consentData.accessUpTo && <p style={{ marginBottom: '15px' }} dangerouslySetInnerHTML={{ __html: consentData.accessUpTo }}></p>}
                            </div>
                        )}                        

                        {consentData.accessExpiry &&
                            (consentData.accessExpiry.title || consentData.accessExpiry.description) && (
                            <div className="access-expiry">
                                {consentData.accessExpiry.title && <h6><strong>{consentData.accessExpiry.title}</strong></h6>}
                                {consentData.accessExpiry.description && <ExpandableText text={consentData.accessExpiry.description} limitConfig={{ default: { charLimit: 250, wordLimit: 18 } }} />}
                            </div>
                        )}

                        {consentData.howExperianUseData &&
                            (consentData.howExperianUseData.title || consentData.howExperianUseData.description) && (
                            <div className="how-experian-use-section">
                                {consentData.howExperianUseData.title && <h6><strong>{consentData.howExperianUseData.title}</strong></h6>}
                                {consentData.howExperianUseData.description && <ExpandableText text={consentData.howExperianUseData.description} />}
                            </div>
                        )}

                        {consentData.deIdentification &&
                            (consentData.deIdentification.title || consentData.deIdentification.description) && (
                            <div className="de-identification-section">
                                {consentData.deIdentification.title && <h6><strong>{consentData.deIdentification.title}</strong></h6>}
                                {consentData.deIdentification.description && (
                                    <p style={{ marginBottom: '15px' }}>
                                        <input
                                            type="checkbox"
                                            name="is_deidentified"
                                            checked={isDeidentified}
                                            onChange={(event) => setIsDeidentified(event.target.checked)}
                                        />{' '}
                                        <span dangerouslySetInnerHTML={{ __html: consentData.deIdentification.description }}></span>
                                    </p>
                                )}
                            </div>
                        )}

                        {consentData.consentManagement &&
                            (consentData.consentManagement.title || consentData.consentManagement.description) && (
                            <div className="consent-management-section">
                                {consentData.consentManagement.title && <h6><strong>{consentData.consentManagement.title}</strong></h6>}
                                {consentData.consentManagement.description && <ExpandableText text={consentData.consentManagement.description} />}
                            </div>
                        )}

                        {consentData.finalConsentPrompt && <h6><strong>{consentData.finalConsentPrompt}</strong></h6>}
                        {consentData.acceptanceNote && <p>{consentData.acceptanceNote}</p>}
                    </div>

                    <div className="form-group">
                        <button
                            type="submit"
                            title="I Consent"
                            className="form-control btn btn-primary"
                            onClick={onSubmit}
                        >
                            I Consent
                        </button>
                    </div>
                    <CancelLogin
                        action={onCancel}
                        theme={props.theme}
                        backToSelectionBtnText={backToSelectionBtnText}
                        requireWinz={requireWinz}
                    />
                </div>
            </div>
        </div>
    );
};

export default Consent;
